export default __webpack_public_path__ + "static/media/zenith.5896e05e.jpg";